import { useState, useEffect } from 'react';
import { auth, useThemeAuthUser } from '@olo-web/utils/google/firebase';

export const useIsAdmin = (): boolean => {
  const [token, setToken] = useState(null);
  const user = useThemeAuthUser();

  const getToken = async () => {
    const t = await auth().currentUser?.getIdTokenResult(true);
    setToken(t ?? null);
  };

  useEffect(() => {
    getToken();
  }, [user]);

  return !!token?.claims?.admin;
};
